import React from "react";
import googleStore from "../../../images/phone/google_play_store.png";
import appleStore from "../../../images/phone/apple_play_store.png";
import phoneX from "../../../images/phone/phone_X.png";
import "./Access.css";

const Access = ({ useWindowSize }) => {
  // const [addBr, setAddBr] = useState(true);
  // const width = useWindowSize;
  // console.log(width);
  // useEffect(() => {
  //   if (width < 668) {
  //     setAddBr(false);
  //   } else {
  //     setAddBr(false);
  //   }
  // }, [width]);
  // console.log(addBr);
  return (
    <div className="bg-white  py-5">
      <div className="container access">
        <div className="row">
          <div className="col-4 col-md-5 col-lg-3">
            <div className="phone_img">
              <img src={phoneX} alt="" />
            </div>
          </div>
          <div className="col-8 col-md-7 col-lg-7 ">
            <div className="access_left">
              <div className="access_text">
                <h1>
                  <span className="text-yellow">Access</span>
                  <span className="text-blue"> from any where</span>
                </h1>
                <p className="m-0 pb-0">
                  We Share app is convenient and easy to use.
                </p>
                <p className="m-0 pb-0">
                  Find what you need, manage your rentals and purchases, and get
                  instant updates.
                </p>
                <p className="m-0">Get it now on iOS and Android.</p>
                <div className="py-1 ">
                  <img className="google" src={googleStore} alt="" />
                  <br />
                  <img className="apple mt-3" src={appleStore} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Access;
